import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import {
  SortContainer,
  SortTrigger,
  SortSelectedOption,
  SortActionIcon,
  SortModalContainer,
  SortOption,
} from './OrderByModal.style';
import { getLabelMessage } from '../../const/labelService';
import useCloseoutside from '../../hooks/useCloseOutside';

const OrderByModal = ({ onOptionClick }) => {
  const labels = [
    'multimediaOrderByLabel',
    'multimediaCreationDate',
    'sortByCreatedAtLabel',
    'sortByNameLabel',
  ];
  const lbls = getLabelMessage(labels);

  const { ref, isActive, setIsActive } = useCloseoutside(false);

  const [selectedOption, setSelectedOption] = useState('creationDate'); // creationDate, name

  const onClick = (option) => {
    setSelectedOption(option);
    onOptionClick(option);
    setIsActive(false);
  };

  return (
    <SortContainer ref={ref}>
      <SortTrigger onClick={() => setIsActive(!isActive)}>
        <SortSelectedOption>
          {selectedOption === 'creationDate' ? lbls.multimediaCreationDate : lbls.sortByNameLabel}
        </SortSelectedOption>
        <SortActionIcon icon={faCaretDown} className={isActive ? 'open' : ''} />
      </SortTrigger>
      {isActive && (
        <SortModalContainer>
          <SortOption
            className={selectedOption === 'creationDate' ? 'active' : ''}
            onClick={() => onClick('creationDate')}
          >
            {lbls.sortByCreatedAtLabel}
          </SortOption>
          <SortOption
            className={selectedOption === 'name' ? 'active' : ''}
            onClick={() => onClick('name')}
          >
            {lbls.sortByNameLabel}
          </SortOption>
        </SortModalContainer>
      )}
    </SortContainer>
  );
};

OrderByModal.propTypes = {
  onOptionClick: PropTypes.func,
};

export default OrderByModal;
